import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './/app-routing.module';
import { InicioComponent } from './inicio/inicio.component';
import { DiretoriaInternacionalComponent } from './diretoria-internacional/diretoria-internacional.component';
import { DiretoriaNacionalComponent } from './diretoria-nacional/diretoria-nacional.component';
import { NadhmiComponent } from './nadhmi/nadhmi.component';
import { FinancaComponent } from './financa/financa.component';
import { ImoveisComponent } from './imoveis/imoveis.component';
import { HotelComponent } from './hotel/hotel.component';
import { MarketingComponent } from './marketing/marketing.component';
import { FarmaceuticaComponent } from './farmaceutica/farmaceutica.component';
import { GmhAlimentosComponent } from './gmh-alimentos/gmh-alimentos.component';
import { GmhHospitalidadeComponent } from './gmh-hospitalidade/gmh-hospitalidade.component';
import { TrabalheConoscoComponent } from './trabalhe-conosco/trabalhe-conosco.component';
import { SafePipe } from './safe.pipe';
import { ProjetosBrasilComponent } from './projetos-brasil/projetos-brasil.component';
import { FaleConoscoComponent } from './fale-conosco/fale-conosco.component';
import { BannerComponent } from './banner/banner.component'
import { EnviarEmailService } from './enviaremail.service';
import { GaleriaComponent } from './galeria/galeria.component'

import { HttpModule } from '@angular/http'
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { EditableDirective } from './editable.directive';
import { LoginComponent } from './login/login.component';
import { LoginService } from './login.service'
import { FormsModule } from '@angular/forms';
import { PostsComponent } from './posts/posts.component';
import { Article1Component } from './article1/article1.component';
import { PostService } from './post.service'
import { ComponentDataService } from './component-data.service'


@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    DiretoriaInternacionalComponent,
    DiretoriaNacionalComponent,
    NadhmiComponent,
    FinancaComponent,
    ImoveisComponent,
    HotelComponent,
    MarketingComponent,
    FarmaceuticaComponent,
    GmhAlimentosComponent,
    GmhHospitalidadeComponent,
    TrabalheConoscoComponent,
    SafePipe,
    ProjetosBrasilComponent,
    FaleConoscoComponent,
    BannerComponent,
    GaleriaComponent,

    PostsComponent,
    Article1Component,
    EditableDirective,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [EnviarEmailService, PostService, ComponentDataService, LoginService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts